export default function expressionToWidth(expression: `${number}/${number}`) {
  let [a, b = 1] = expression.split('/');
  return (Number(a) / Number(b)) * 100 + '%';
}
